import { Component, Inject, Input, OnInit } from '@angular/core';
import { FormControl, FormControlName, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { customValidationService } from 'src/app/shared/custom.validator';
import { CollectionService } from '@services/collection.service';
import { Subscription } from 'rxjs';
import { NotificationService } from '@services/notification.service';
import { WebErrorService } from '@services/webError.service';
@Component({
  selector: 'app-create-new-style',
  templateUrl: './create-new-style-group.component.html',
  styleUrls: ['./create-new-style-group.component.scss']
})
export class CreateNewStyleGroupComponent implements OnInit {
  isNewStyleGroup: boolean = true;
  basicDetailsForm: FormGroup;
  @Input() isPublished: any;
  newStyleGroupSubscription: Subscription;
  updateStyleGroupSubscription: Subscription;
  globalcollectionuuId: any;
  styleGroupData: any;
  styleGroupId: any;
  constructor(
    public dialogRef: MatDialogRef<CreateNewStyleGroupComponent>,
    private CollectionService: CollectionService,
    private notificationService: NotificationService,
    private webErrorService: WebErrorService,
    @Inject(MAT_DIALOG_DATA) public Data: any) {
      this.globalcollectionuuId = JSON.parse(sessionStorage.getItem('defaultcollectionuuid'));
    }

  ngOnInit(): void {
    this.createForm();

    if (this.Data != null) {
      this.styleGroupData = this.Data.data;
      this.styleGroupId = this.Data.styleGroupId;

      if (this.styleGroupId) {
        this.isNewStyleGroup = false;
        this.basicDetailsForm.setValue({
          styleGroupId: this.styleGroupId,
          styleGroupName: this.styleGroupData.styleGroupName,
          description: this.styleGroupData.description
        });
      }
    }
  }

  createForm(): void {
    this.basicDetailsForm = new FormGroup({
      styleGroupId: new FormControl(0),
      styleGroupName: new FormControl('', [
        Validators.required,
        Validators.minLength(1),
        Validators.maxLength(120),
        customValidationService.cannotContainSpace,
        Validators.pattern(/^[ a-zA-Z.-]+([ ]?[a-z0-9 !#|^*()-_@$!%*?&]){0,}$/)
      ]
      ),
      description: new FormControl('',
        [
          Validators.minLength(1),
          Validators.maxLength(480),
        ]
      )
    });
  }

  get f() {
    return this.basicDetailsForm.controls;
  }

  saveStyleGroupDetails() {
    if (this.basicDetailsForm.valid) {
      if (this.isNewStyleGroup) {
        this.newStyleGroupSubscription = this.CollectionService.addNewStyleGroup(this.globalcollectionuuId, this.basicDetailsForm.value).subscribe((resData) => {
          if (resData.success) {
            this.notificationService.success(resData.message);
            this.closeDialog();
          }
        }, (error: any) => { this.webErrorService.handleAPIErrors(error, '', true, 'warn'); });
      } else {
        this.updateStyleGroupSubscription = this.CollectionService.updateStyleGroup(this.globalcollectionuuId, this.basicDetailsForm.value).subscribe((resData) => {
          if (resData.success) {
            this.notificationService.success(resData.message);
            this.closeDialog();
          }
        }, (error: any) => { this.webErrorService.handleAPIErrors(error, '', true, 'warn'); });
      }
    }
  }

  closeDialog() {
    this.dialogRef.close("noitem");
  }

  ngOnDestroy(): void {
    if (this.newStyleGroupSubscription) {
      this.newStyleGroupSubscription.unsubscribe();
    }
    if (this.updateStyleGroupSubscription) {
      this.updateStyleGroupSubscription.unsubscribe();
    }
  }
}
